import { useIntl } from "react-intl";

import UFOLabel from "@atlaskit/react-ufo/label";

import {
    type LanguageSelectorProps,
    default as LanguageSelectorSync
} from "./language-selector";

export const LanguageSelector = ({
    selectedLanguage,
    onLanguageChangeHandler,
    className,
    testId
}: LanguageSelectorProps) => {
    const intl = useIntl();

    if (!selectedLanguage) {
        selectedLanguage = intl.locale || "en";
    }

    return (
        <UFOLabel name="global-footer-v2-language-selector">
            <LanguageSelectorSync
                selectedLanguage={selectedLanguage}
                onLanguageChangeHandler={onLanguageChangeHandler}
                className={className}
                testId={testId}
            />
        </UFOLabel>
    );
};
